import {SLIDER_CONSTS} from "../constants";

export const initialState = {
    sliderList: [],
    sliderById: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SLIDER_CONSTS.GET_SLIDERS:
            return {
                ...state,
                sliderList: action.payload || [],
            };
        case SLIDER_CONSTS.CREATE_SLIDER:
            return {
                ...state,
                sliderList: [action.payload].concat(state.sliderList)
            };
        case SLIDER_CONSTS.DELETE_SLIDER_BY_ID:
            return {
                ...state,
                sliderList: state.sliderList.filter(item => item.id !== action.payload)
            };
        default:
            return state;
    }
}
